export { ProfilePointCardComponent } from './profile-point-card/profile-point-card.component';
export { ProfileImageWithProgressComponent } from './profile-image-with-progress/profile-image-with-progress.component';